export const uniqueArray = (list: string[]) => {
  return Array.from(new Set(list));
};
